import {
  GET_CATEGORIES_REQUESTED,
  GET_CATEGORIES_SUCCEEDED,
  GET_CATEGORIES_FAILED,
  UPDATE_CATEGORIES_REQUESTED,
  UPDATE_CATEGORIES_SUCCEEDED,
  UPDATE_CATEGORIES_FAILED,
  CREATE_CATEGORY_REQUESTED,
  CREATE_CATEGORY_SUCCEEDED,
  CREATE_CATEGORY_FAILED,
} from './constants'
import api from 'utils/api'

//get
export const getCategoriesRequested = () => ({
  type: GET_CATEGORIES_REQUESTED,
})

export const getCategoriesSucceeded = (payload) => ({
  type: GET_CATEGORIES_SUCCEEDED,
  payload,
})

export const getCategoriesFailed = () => ({
  type: GET_CATEGORIES_FAILED,
})

export const loadCategories = (venueUuid) => (dispatch) => {
  dispatch(getCategoriesRequested())

  return api
    .fetchCategories(venueUuid)
    .then((response) =>
      dispatch(getCategoriesSucceeded(response.data.itemCategories))
    )
    .catch(() => dispatch(getCategoriesFailed()))
}

export const createCategoryRequested = () => ({
  type: CREATE_CATEGORY_REQUESTED,
})

export const createCategorySucceeded = (payload) => ({
  type: CREATE_CATEGORY_SUCCEEDED,
  payload,
})

export const createCategoryFailed = () => ({
  type: CREATE_CATEGORY_FAILED,
})

export const createCategory = (data) => (dispatch) => {
  dispatch(createCategoryRequested())

  const params = { itemCategories: data }

  return api
    .createCategory(params)
    .then((response) =>
      dispatch(createCategorySucceeded(response.data.itemCategories))
    )
    .catch(() => dispatch(createCategoryFailed()))
}

export const updateCategoriesRequested = () => ({
  type: UPDATE_CATEGORIES_REQUESTED,
})

export const updateCategoriesSucceeded = (payload) => ({
  type: UPDATE_CATEGORIES_SUCCEEDED,
  payload,
})

export const updateCategoriesFailed = () => ({
  type: UPDATE_CATEGORIES_FAILED,
})

export const updateCategories = (data) => (dispatch) => {
  dispatch(updateCategoriesRequested())

  const params = { itemCategories: data }

  return api
    .updateCategory(params)
    .then((response) =>
      dispatch(
        updateCategoriesSucceeded(response.data.itemCategories)
      )
    )
    .catch(() => dispatch(updateCategoriesFailed()))
}
